<div class="content-block">
  <article class="article " style="margin-top:1rem">

    <div class="title-container">
      <button class="btn btn-back" (click)="back()"><i class="fas fa-caret-left"></i> Back</button>
      <div style="flex: 10;">
        <h2>{{location.name}}'s' Sublocation Management</h2>
      </div>
      <div style="flex:1;justify-content: flex-end;display: flex;">
        <div class="add" (click)="add()" *ngIf="!readOnly">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </div>
      </div>
    </div>




    <form class="card-title form-column " style="width: 100%;padding: 0.5rem;margin-top: 0.5rem;" (submit)="rebind()">
      <div class="form-row borderless " style="padding:0px;margin:0px;">

        <div class="col-md-3">
          <label>Name</label>
          <input type="text" style="width: 100%;" name="name" [(ngModel)]="filter.name" />
        </div>
        <div class="col-md-3"></div>

        <div class="col-md-3 col-sm-6"></div>
        <div class="col-md-3 col-sm-6">
          <label></label>
          <div class="btn-container" style="justify-content: flex-end;min-height: 57px;">

            <button class="btn btn-secondary" style="margin-right:1rem" (click)="resetFilters()">Reset</button>
            <button class="btn btn-primary" style="margin-right:1.25rem" value="Refresh">Refresh</button>
          </div>
        </div>

      </div>

    </form>

    <app-loading-icon *ngIf="loading"></app-loading-icon>

    <div class="form-column borderless" style="display: block;">

      <ngx-datatable [count]="page.totalElements" [offset]="page.pageNumber" [limit]="page.size" [headerHeight]="50"
        [footerHeight]="50" (page)='setPage($event)' (sort)="onSort($event)" class="material" [rows]="rows"
        [rowClass]="getRowClass" [columnMode]="'force'" [externalPaging]="true" [externalSorting]="true"
        [rowHeight]="'auto'">

        <ngx-datatable-column name="Name" prop="name">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Option" *ngIf="!readOnly">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <span style="padding:1%" (click)="edit(row)" class="edit-option danger "><i class="fa fa-pencil"
                aria-hidden="true"></i>
              Edit</span>
          </ng-template>
        </ngx-datatable-column>

      </ngx-datatable>
    </div>
  </article>
</div>

<popup-modal id="popup-sublocation-add">
  <article class="popup-artical">
    <div class="popup-container">
      <div class="popup-header">
        <h2 *ngIf="!editing">Add new Sublocation</h2>
        <h2 *ngIf="editing">Editing Sublocation</h2>
      </div>

      <div class="popup-content">
        <div class="input-column">
          <table>
            <tr>
              <td><label>Name</label></td>
              <td> <input type="text" [(ngModel)]="subLocationName" /></td>
            </tr>
            <tr *ngIf="editing">
              <td><label style="margin-right: 1vw;">Expired</label></td>
              <td> <input type="checkbox" id="switch-1" name="switch-1" role="switch" [(ngModel)]="archived" />
              </td>
            </tr>
          </table>
        </div>

        <div class="popup-footer">
          <div class="btn-container">
            <button class="btn btn-secondary" (click)="cancelModal('popup-sublocation-add')">Cancel</button>
            <button class="btn btn-primary" (click)="saveSubLocation()">Save</button>

          </div>
        </div>
      </div>
    </div>
  </article>

</popup-modal>